import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c65762c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "loading" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 50 50" }, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        "stroke-width": "5"
    })
], -1));
const _hoisted_3 = [
    _hoisted_2
];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        variant: { default: "grey" }
    },
    setup(__props) {
        const props = __props;
        const className = computed(() => ["spinner", props.variant !== "grey" ? `spinner--${props.variant}` : ""].join(" "));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(_unref(className))
                }, _hoisted_3, 2)
            ]));
        };
    }
});
